// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__98mmU","title":"styles_title__SMjVZ","button":"styles_button__+qszU"};